var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPayMent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconPayMent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C7.58172 8 4 11.5817 4 16V32C4 36.4183 7.58172 40 12 40H20C21.1046 40 22 39.1046 22 38C22 36.8954 21.1046 36 20 36H12C9.79086 36 8 34.2091 8 32V22H40V23C40 24.1046 40.8954 25 42 25C43.1046 25 44 24.1046 44 23V16C44 11.5817 40.4183 8 36 8H12ZM40 16C40 13.7909 38.2091 12 36 12H12C9.79086 12 8 13.7909 8 16L40 16Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 34C24 28.4769 28.4769 24 34 24C39.5231 24 44 28.4769 44 34C44 39.5231 39.5231 44 34 44C28.4769 44 24 39.5231 24 34ZM40.4033 32.3379C41.1423 31.6729 41.2022 30.5348 40.5371 29.7959C39.8721 29.0569 38.734 28.997 37.9951 29.6621L32.5325 34.5783L30.4033 32.6621C29.6644 31.997 28.5263 32.0569 27.8613 32.7959C27.1962 33.5348 27.2561 34.6729 27.9951 35.3379L31.3284 38.3379C32.0129 38.954 33.0521 38.954 33.7367 38.3379L40.4033 32.3379Z",
    fill: "#71869D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayMent);
export default __webpack_public_path__ + "static/media/iconPayMent.44dbe2e7fec7e3cdf99792f228427a75.svg";
export { ForwardRef as ReactComponent };